import gql from 'graphql-tag';

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsRead($data: MarkAsReadInput!) {
    markNotificationAsRead(data: $data) {
      ... on MarkAsRead {
        message
        version
        notification {
          id
          readAt
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllNotificationsAsRead($data: MarkAllAsReadInput) {
    markAllNotificationsAsRead(data: $data) {
      ... on MarkAllAsRead {
        message
        version
        updatedCount
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation DeleteNotification($data: DeleteNotificationInput!) {
    deleteNotification(data: $data) {
      ... on DeleteNotification {
        message
        version
        deletedId
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const ARCHIVE_NOTIFICATION = gql`
  mutation ArchiveNotification($data: ArchiveNotificationInput!) {
    archiveNotification(data: $data) {
      ... on ArchiveNotification {
        message
        version
        notification {
          id
          status
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const SNOOZE_NOTIFICATION = gql`
  mutation SnoozeNotification($data: SnoozeNotificationInput!) {
    snoozeNotification(data: $data) {
      ... on SnoozeNotification {
        message
        version
        notification {
          id
          status
        }
        snoozedUntil
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const REGISTER_FCM_DEVICE = gql`
  mutation RegisterFCMDevice($input: RegisterFCMDeviceInput!) {
    registerFCMDevice(input: $input) {
      ... on RegisterFCMDevice {
        message
        device {
          id
          platform
          deviceId
          fcmToken
          deviceName
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const UPDATE_FCM_DEVICE = gql`
  mutation UpdateFCMDevice($input: UpdateFCMDeviceInput!) {
    updateFCMDevice(input: $input) {
      ... on DeviceUpdate {
        message
        device {
          id
          platform
          deviceId
          fcmToken
          deviceName
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;
